document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const HELP_CENTER_BLOG_PATH = '/blogs/help-center/';
  const locale = (document.documentElement.lang || 'it').toLowerCase();
  const language = locale.split('-')[0];
  const labelsByLanguage = {
    it: {
      readingTimeLabel: 'min di lettura',
      noResultsLabel: 'Nessun risultato pertinente nel Help Center.',
      articlesLabel: 'Articoli Help Center',
      suggestionsLabel: 'Suggerimenti',
      fallbackMetaLabel: 'Help Center',
    },
    en: {
      readingTimeLabel: 'min read',
      noResultsLabel: 'No relevant results found in the Help Center.',
      articlesLabel: 'Help Center articles',
      suggestionsLabel: 'Suggestions',
      fallbackMetaLabel: 'Help Center',
    },
    es: {
      readingTimeLabel: 'min de lectura',
      noResultsLabel: 'No se han encontrado resultados relevantes en el Help Center.',
      articlesLabel: 'Artículos del Help Center',
      suggestionsLabel: 'Sugerencias',
      fallbackMetaLabel: 'Centro de ayuda',
    },
    fr: {
      readingTimeLabel: 'min de lecture',
      noResultsLabel: 'Aucun résultat pertinent trouvé dans le Help Center.',
      articlesLabel: 'Articles du Help Center',
      suggestionsLabel: 'Suggestions',
      fallbackMetaLabel: 'Centre d’aide',
    },
    de: {
      readingTimeLabel: 'Min. Lesezeit',
      noResultsLabel: 'Keine passenden Ergebnisse im Help Center gefunden.',
      articlesLabel: 'Help-Center-Artikel',
      suggestionsLabel: 'Vorschläge',
      fallbackMetaLabel: 'Hilfe-Center',
    },
  };
  const activeLabels = labelsByLanguage[language] || labelsByLanguage.it;
  const { readingTimeLabel, noResultsLabel, articlesLabel, suggestionsLabel, fallbackMetaLabel } =
    activeLabels;
  const escapeHtml = (value) =>
    String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');

  const featuredList = document.querySelector('[data-help-center-featured-list]');
  const featuredDataScript = document.querySelector('[data-help-center-featured-data]');

  if (featuredList && featuredDataScript) {
    try {
      const articles = JSON.parse(featuredDataScript.textContent || '[]').filter(
        (article) => article?.title && article?.url,
      );

      const shuffled = [...articles]
        .sort(() => Math.random() - 0.5)
        .slice(0, 6);

      featuredList.innerHTML = shuffled
        .map((article) => {
          const readingTime = article.reading_minutes
            ? `
              <span class="help-center-article-meta__reading-time">
                <svg aria-hidden="true" viewBox="0 0 14 14" focusable="false">
                  <circle cx="7" cy="7" r="5.5"></circle>
                  <path d="M7 3.8v3.5l2.3 1.5"></path>
                </svg>
                ${escapeHtml(article.reading_minutes)} ${readingTimeLabel}
              </span>
            `
            : '';

          return `
            <a class="help-center-article-card" href="${article.url}">
              <div class="help-center-article-card__content">
                <h3 class="help-center-article-card__title">${escapeHtml(article.title)}</h3>
                ${readingTime ? `<div class="help-center-article-card__meta">${readingTime}</div>` : ''}
              </div>
            </a>
          `;
        })
        .join('');
    } catch (error) {
      featuredList.innerHTML = '';
    }
  }

  const tocRoot = document.querySelector('[data-help-center-toc]');
  const articleBody = document.querySelector('[data-help-center-body]');

  if (tocRoot && articleBody) {
    const headings = articleBody.querySelectorAll('h2[id], h3[id]');

    headings.forEach((heading) => {
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      tocRoot.appendChild(link);
    });

    if (!headings.length) {
      tocRoot.closest('.help-center-sidebar-card')?.setAttribute('hidden', 'hidden');
    }
  }

  const searchForms = document.querySelectorAll('[data-help-center-search-form]');

  searchForms.forEach((form) => {
    const input = form.querySelector('input[name="q"]');
    const predictiveRoot = form.querySelector('[data-help-center-predictive]');
    let abortController = null;

    const closePredictive = () => {
      if (predictiveRoot) {
        predictiveRoot.hidden = true;
        predictiveRoot.innerHTML = '';
      }
      input?.setAttribute('aria-expanded', 'false');
    };

    const stripHtml = (value) =>
      String(value ?? '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const renderPredictive = (query, articles, queries) => {
      if (!predictiveRoot) return;

      if (!articles.length && !queries.length) {
        predictiveRoot.innerHTML = `<div class="help-center-predictive__empty">${noResultsLabel}</div>`;
        predictiveRoot.hidden = false;
        input?.setAttribute('aria-expanded', 'true');
        return;
      }

      const articleMarkup = articles.length
        ? `
          <div class="help-center-predictive__section">
            <div class="help-center-predictive__label">${articlesLabel}</div>
            <div class="help-center-predictive__list">
              ${articles
                .map((article) => {
                  const meta = article.tags?.[0] ? escapeHtml(article.tags[0]) : fallbackMetaLabel;
                  const excerpt = escapeHtml(stripHtml(article.summary_html).slice(0, 140));
                  return `
                    <a class="help-center-predictive__item" href="${article.url}">
                      <div class="help-center-predictive__meta">${meta}</div>
                      <div class="help-center-predictive__title">${escapeHtml(article.title)}</div>
                      ${excerpt ? `<div class="help-center-predictive__excerpt">${excerpt}</div>` : ''}
                    </a>
                  `;
                })
                .join('')}
            </div>
          </div>`
        : '';

      const queryMarkup = queries.length
        ? `
          <div class="help-center-predictive__section">
            <div class="help-center-predictive__label">${suggestionsLabel}</div>
            <div class="help-center-predictive__queries">
              ${queries
                .map(
                  (item) => `
                    <a class="help-center-predictive__query" href="${item.url}">${item.styled_text || escapeHtml(item.text)}</a>
                  `,
                )
                .join('')}
            </div>
          </div>`
        : '';

      predictiveRoot.innerHTML = `
        ${articleMarkup}
        ${queryMarkup}
      `;
      predictiveRoot.hidden = false;
      input?.setAttribute('aria-expanded', 'true');
    };

    const fetchPredictive = async (query) => {
      if (!predictiveRoot || !input) return;
      if (query.length < 2) {
        closePredictive();
        return;
      }

      abortController?.abort();
      abortController = new AbortController();

      const root = window.Shopify?.routes?.root || '/';
      const base = `${root}search/suggest.json`;
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'article,query',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][fields]': 'title,tag,body',
      });

      try {
        const response = await fetch(`${base}?${params.toString()}`, {
          signal: abortController.signal,
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

        const data = await response.json();
        const resources = data.resources?.results || {};
        const articles = (resources.articles || [])
          .filter((article) => article.url?.includes(HELP_CENTER_BLOG_PATH))
          .slice(0, 5);
        const queries = (resources.queries || []).slice(0, 4);

        renderPredictive(query, articles, queries);
      } catch (error) {
        if (error.name === 'AbortError') return;
        closePredictive();
      }
    };

    form.addEventListener('submit', (event) => {
      if (!input || !input.value.trim()) {
        event.preventDefault();
      }
    });

    if (input && predictiveRoot) {
      const debounced = (() => {
        let timeoutId;
        return () => {
          window.clearTimeout(timeoutId);
          timeoutId = window.setTimeout(() => {
            fetchPredictive(input.value.trim());
          }, 220);
        };
      })();

      input.addEventListener('input', debounced);
      input.addEventListener('focus', debounced);

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) {
          closePredictive();
        }
      });

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          closePredictive();
        }
      });
    }
  });
});
